import { EmploymentType } from '../../../Types/Portfolio/EmploymentType';

export const DominionVotingSystems: EmploymentType = {
	company: 'Dominion Voting Systems (DVS)',
	position: 'Software Engineer',
	objective: 'A company that makes voting machines to be used in elections.',
	logo: 'https://assets.dear-ux.com/faizhirani/images/logos/DVS.svg',
};
